import {Dispatch, SetStateAction} from "react";
import { useQuery } from "react-query";
import { getParesResult } from "./gateway";

function useGetParesResult({
  merchantReference,
  enabled,
  setEnableParesPoll,
  setEnableCompletePares,
}: {
  merchantReference: string;
  enabled: boolean;
  setEnableParesPoll: Dispatch<SetStateAction<boolean>>;
  setEnableCompletePares: Dispatch<SetStateAction<boolean>>;
}) {
  return useQuery({
    queryFn: () => getParesResult(merchantReference),
    queryKey: ["getParesResult", merchantReference],
    enabled,
    refetchInterval: 2000,
    retry: true,
    onSuccess: (data) => {
      if (data?.data?.ready) {
        setEnableParesPoll(false);
        setEnableCompletePares(true);
      }
    },
  });
}

export default useGetParesResult;
